import { EntityName } from '@adm/backend-entity';

import { DefaultAction, Models, UserRole } from '../../enums';

const Actions = {
  ...DefaultAction,
};

export const brandPermissions: Record<
  UserRole,
  { actions: Array<keyof typeof Actions>; subject: Models; fields?: Array<EntityName> }[]
> = {
  [UserRole.Admin]: [
    { actions: [Actions.read, Actions.update, Actions.create], subject: Models.Brand },
    { actions: [Actions.read], subject: Models.Brands },
  ],

  [UserRole.Operator]: [
    { actions: [Actions.read, Actions.update, Actions.create], subject: Models.Brand },
    { actions: [Actions.read], subject: Models.Brands },
  ],

  [UserRole.OperatorWithoutPBAccess]: [
    { actions: [Actions.read, Actions.update, Actions.create], subject: Models.Brand },
    { actions: [Actions.read], subject: Models.Brands },
  ],

  [UserRole.DeviceOperator]: [],

  [UserRole.OperatorReadAccess]: [
    { actions: [Actions.read], subject: Models.Brand },
    { actions: [Actions.read], subject: Models.Brands },
  ],

  [UserRole.TtmOperator]: [],

  [UserRole.DeviceQualityOperator]: [],
};
